import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop", "arrow"]

  connect() {
    const currentTemplateId = window.location.pathname.split('/').pop()
    const storedTemplateId = sessionStorage.getItem('mobileTemplateBarTemplateId')
    const wasExpanded = sessionStorage.getItem('mobileTemplateBarExpanded') === 'true'

    this.isExpanded = false

    if (wasExpanded && storedTemplateId === currentTemplateId) {
      setTimeout(() => {
        this.openWithoutAnimation()
      }, 50)
    } else {
      sessionStorage.setItem('mobileTemplateBarExpanded', 'false')
      sessionStorage.setItem('mobileTemplateBarTemplateId', currentTemplateId)
    }
  }

  disconnect() {
    document.body.style.overflow = ''
  }

  toggle() {
    if (this.isExpanded) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.panelTarget.style.transform = 'translateY(0)'
    this.backdropTarget.style.display = 'block'
    this.arrowTarget.style.transform = 'rotate(180deg)'
    this.isExpanded = true
    document.body.style.overflow = 'hidden'

    const currentTemplateId = window.location.pathname.split('/').pop()
    sessionStorage.setItem('mobileTemplateBarExpanded', 'true')
    sessionStorage.setItem('mobileTemplateBarTemplateId', currentTemplateId)
  }

  openWithoutAnimation() {
    const originalTransition = this.panelTarget.style.transition
    this.panelTarget.style.transition = 'none'

    this.panelTarget.style.transform = 'translateY(0)'
    this.backdropTarget.style.display = 'block'
    this.arrowTarget.style.transform = 'rotate(180deg)'
    this.isExpanded = true
    document.body.style.overflow = 'hidden'

    setTimeout(() => {
      this.panelTarget.style.transition = originalTransition
    }, 10)

    const currentTemplateId = window.location.pathname.split('/').pop()
    sessionStorage.setItem('mobileTemplateBarExpanded', 'true')
    sessionStorage.setItem('mobileTemplateBarTemplateId', currentTemplateId)
  }

  close() {
    this.panelTarget.style.transform = 'translateY(100%)'
    this.backdropTarget.style.display = 'none'
    this.arrowTarget.style.transform = 'rotate(0deg)'
    this.isExpanded = false
    document.body.style.overflow = ''

    sessionStorage.setItem('mobileTemplateBarExpanded', 'false')
  }
}
